import { useAppSelector } from '@/hooks/use-app-selector'
import { IMultiLevelMenu } from '@interfaces/interfaces'
import React from 'react'
import { Navigation } from '../Base/Navigation/Navigation'

export const RVDashboardNavigation: React.FC = () => {
  const reportId = useAppSelector((s) => s.axiomReport.selectedReport.reportId)
  const AttributionOverview: IMultiLevelMenu = {
    isDownArrow: false,
    heading: 'Attribution Overview',
    isMenuList: false,
    route: `/reports/${reportId}/rv/dashboard`,
  }
  const DailyAttribution: IMultiLevelMenu = {
    isDownArrow: false,
    heading: 'Daily Attribution',
    isMenuList: false,
    route: `/reports/${reportId}/rv/summary`,
  }
  const SecurityDetails: IMultiLevelMenu = {
    isDownArrow: false,
    heading: 'Security Details',
    isMenuList: false,
    route: `/reports/${reportId}/rv/details`,
  }

  const headerMenuItems: IMultiLevelMenu[] = [
    AttributionOverview,
    DailyAttribution,
    SecurityDetails,
  ]
  return (
    <Navigation
      headerMenuItems={headerMenuItems}
      highlightActive={true}
      paddingHorizontal={0}
    />
  )
}
